import React from 'react';
import SquareAvatar from '../../commonComponent/SquareAvatar';
import ApiConfig from '../../config/ApiConfig';
import {  formatNewDateString, showToastError, showToastSuccess } from '../../Utils/Helper';
import { FiEye, FiTrash } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { removeIdByType } from '../../services/GroupService';

const MyGroupActiveProgramList = ({ list,group,getdata,getprogramdata }) => {

  const removeProgramById = async(id) =>{
    let params = {}
    params['groupId'] = group.selectedgroup._id;
    params['type'] = 'program';
    params['typeId'] = id;
    console.log(params)
    try {
      const response = await removeIdByType(params);
      if(response?.data?.status === 200){
        showToastSuccess('Program Removed')
        getdata()
        getprogramdata()
        console.log(response)
      }else{
        showToastError('Error Occured')
      }
    } catch (error) {
      showToastError(error || 'Error Occured from catch')
    }

  }

  const navigate = useNavigate()
  return (
    <>{list?.map((item) =>
      <div key={item._id} className="card shadow-sm rounded mt-3 px-3 py-4">
        <div className="row">
          <div className="col-md-1 text-center">
            <SquareAvatar
              src={ApiConfig.ImageUrl + 'programs/' + item.createdBy + '/' + item.programImage}
              className="member_listimage rounded"
            />
          </div>

          <div className="col-md-11">
            <h5>{item.programName}</h5>
            <p className="resFont">{item.description}</p>
            <div className="table_resouter card bg-light p-2">
              <table class="table mb-0 table-borderless table_resinner4">
                <tbody>
                  <tr>
                    <td><span className="fw-bold">Start Date:</span> {formatNewDateString(item.startDate)}</td>
                    <td className='text-capitalize'><span className="fw-bold">Program Type:</span> {item.programType}</td>
                    <td><span className="fw-bold">Status:</span> {item.status ? <span className='text-success'>◉ Active</span> : <span className='text-danger'>◉ In Active</span>}</td>
                  </tr>
                  <tr>
                    <td><span className="fw-bold">End Date:</span>  {formatNewDateString(item.endDate)}</td>
                    <td><span className="fw-bold">Price:</span> {item.price}</td>
                    <td className=''>
                      <button className='btn btn-light me-2' onClick={()=>navigate('/activeprograminfo',{state:{program:item}})}><FiEye/></button>
                      {/* <button className='btn btn-light me-2'><FiEdit/></button> */}
                      <button className='btn btn-light me-2' onClick={()=>removeProgramById(item._id)}><FiTrash/></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>)}
    </>
  )
}

export default MyGroupActiveProgramList;